import * as _ from 'underscore'

import { Enums } from '../../models/common'

import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../user-session'


//#region Consts

export const OPERATOR_SETTINGS_SERVICE_NAME: string = 'OperatorSettingsService'
export const OPERATOR_SETTINGS_SERVICE_PROVIDER_NAME: string = 'OperatorSettingsServiceProvider'

//#endregion

export type OperatorProfileDateFormats = {
    shortFormat: string
    longFormat: string
}

export class OperatorSettingsService {

    //#region Ctor

    constructor(private userSessionService: UserSessionService) { }

    //#endregion

    //#region Date

    public getDateFormats(): JQueryPromise<OperatorProfileDateFormats> {
        return this.userSessionService
            .getDataProvider()
            .Operator
            .getOperatorSettings(this.userSessionService.getIdLoggedOperator(), [
                Enums.SimaxOperatorSetting.DateFormatLong,
                Enums.SimaxOperatorSetting.DateFormatShort,
            ])
            .then((settings: any[]) => {
                const dateFormats: OperatorProfileDateFormats = {
                    shortFormat: null,
                    longFormat: null
                }

                if (settings != null) {
                    const [longProfileFormat, shortProfileFormat] = settings

                    dateFormats.shortFormat = shortProfileFormat || null
                    dateFormats.longFormat = longProfileFormat || null
                }

                return dateFormats
            })
    }

    //#endregion

    //#region Dictionary

    public hasDictionaryCompleteness(referenceType: Enums.ReferenceType): JQueryPromise<boolean> {
        return this.userSessionService
            .getDataProvider().Operator
            .getOperatorSettings(this.userSessionService.getIdLoggedOperator(), [Enums.SimaxOperatorSetting.DictionaryCompleteness])
            .then((result: any[]) => {
                if (_.size(result) > 0 && _.size(result[0]) && _.size(result[0][0])) {
                    if (result[0][0][0] === referenceType && result[0][0][1]) {
                        return true
                    }
                }

                return false
            });
    }

    //#endregion
}

export class OperatorSettingsServiceProvider implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [USER_SESSION_SERVICE_NAME, function (userSession: UserSessionService) {
        return new OperatorSettingsService(userSession)
    }]

    //#endregion
} 